import React from "react";
import { Page, Document, Image, StyleSheet, Text, View, Font } from "@react-pdf/renderer";

import { generateUUID, pdfLogo } from "utils/common";
import Roboto from "resources/fonts/Roboto-Regular.ttf";
import RobotoBold from "resources/fonts/Roboto-Bold.ttf";

Font.register({ family: "Roboto", src: Roboto });
Font.register({ family: "Roboto-Bold", src: RobotoBold });
const styles = StyleSheet.create({
  noBorder: {
    border: "none",
  },
  header: {
    container: {
      padding: "20px 15px 21px 15px",
      margin: "0 18px 0 0",
    },
    image: {
      height: 70,
      width: 160,
    },
  },
  siteDetails: {
    padding: "31px 32px",
    backgroundColor: "#FFFFFF",
    border: "1px solid #D1D1D1",
    borderRadius: 8,
    marginRight: 10,
    marginLeft: 10,
    fontFamily: "Roboto",
    header: {
      fontSize: 16,
      color: "#454545",
      letterSpacing: 0,
      fontFamily: "Roboto-Bold",
    },
    siteInfoContainer: {
      display: "flex",
      flexDirection: "row",
      fontSize: 12,
      color: "#454545",
      flexWrap: "wrap",
      siteName: {
        display: "flex",
        flexDirection: "column",
        marginRight: 15,
      },
      infoItem: {
        display: "flex",
        flexDirection: "column",
        marginRight: 8,
        width: "30%",
        marginBottom: 18,
      },
      label: {
        marginBottom: 8,
        fontFamily: "Roboto-Bold",
      },
      value: {
        color: "#747474",
      },
    },
  },
  roomView: {
    padding: "31px 32px",
    backgroundColor: "#FFFFFF",
    borderRadius: 8,
    marginRight: 10,
    marginLeft: 10,
    marginTop: 24,
    header: {
      fontSize: 16,
      color: "#454545",
      letterSpacing: 0,
      fontFamily: "Roboto-Bold",
    },
    roomInfoContainer: {
      display: "flex",
      flexDirection: "column",
      fontSize: 12,
      color: "#454545",
      flexWrap: "wrap",
      width: "100%",
      cardContainer: {
        backgroundColor: "#FFFFFF",
        border: "1px solid #dee2e6",
        borderRadius: 4,
        marginBottom: 12,
        width: "100%",
        justifyContent: "center",
        roomInfoCard: {
          padding: "18px 16px",
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          roomNameContainer: {
            width: "22%",
            marginRight: 18,
            value: {
              padding: "4px 8px",
              color: "#454545",
              backgroundColor: "#F8F0CE",
              borderRadius: 4,
            },
          },
        },
        productInfo: {
          border: "1px solid #dee2e6",
          paddingLeft: 16,
          display: "flex",
          flexWrap: "wrap",
          flexDirection: "row",
          productCard: {
            backgroundColor: "#FFFFFF",
            border: "1px solid #dee2e6",
            borderRadius: 8,
            margin: "16px 16px 16px 0",
            width: "45%",
            header: {
              padding: "18px 13px 8px 19px",
              display: "flex",
              justifyContent: "space-between",
            },
            line: {
              display: "block",
              height: 1,
              width: "100%",
              borderBottom: "1px solid #D1D1D1",
              marginTop: 4,
              marginBottom: 4,
            },
            body: {
              margin: "6px 12px",
              display: "flex",
              justifyContent: "center",
              flexDirection: "column",
              itemContainer: {
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                marginBottom: 8,
              },
            },
          },
        },
      },
    },
  },
  productView: {
    padding: "31px 32px",
    backgroundColor: "#FFFFFF",
    borderRadius: 8,
    marginRight: 10,
    marginLeft: 10,
    productNameContainer: {
      width: "100%",
      marginTop: 24,
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
      fontSize: 13,
      fontFamily: "Roboto-Bold",
      value: {
        padding: "4px 8px",
        borderRadius: 4,
      },
    },
    header: {
      fontSize: 16,
      color: "#454545",
      letterSpacing: 0,
    },
    productInfoContainer: {
      display: "flex",
      flexDirection: "column",
      fontSize: 12,
      color: "#454545",
      flexWrap: "wrap",
      width: "100%",
      cardContainer: {
        backgroundColor: "#FFFFFF",
        border: "1px solid #dee2e6",
        borderRadius: 4,
        marginBottom: 12,
        width: "100%",
        justifyContent: "center",
        productInfoCard: {
          padding: "18px 24px",
          display: "flex",
          flexDirection: "row",
          flexWrap: "wrap",
          productNameContainer: {
            marginRight: 18,
            display: "flex",
            flexDirection: "row",
            width: "100%",
            justifyContent: "space-between",
            alignItems: "center",
            fontFamily: "Roboto-Bold",
            value: {
              padding: "4px 8px",
              color: "#454545",
              backgroundColor: "#F8F0CE",
              borderRadius: 4,
            },
          },
          itemContainer: {
            display: "flex",
            flexDirection: "column",
            width: "23%",
            marginRight: 4,
            marginTop: 5,
            label: {
              color: "#454545c2",
              fontSize: 12,
              marginBottom: 4,
            },
            value: {
              fontSize: 12,
            },
          },
        },
        roomInfo: {
          border: "1px solid #dee2e6",
          paddingLeft: 16,
          display: "flex",
          flexWrap: "wrap",
          flexDirection: "row",
          header: {
            padding: "4px 8px",
            marginTop: 6,
            marginBottom: 6,
            width: 150,
            fontFamily: "Roboto-Bold",
          },
          productCard: {
            backgroundColor: "#FFFFFF",
            border: "1px solid #dee2e6",
            borderRadius: 8,
            margin: "16px 16px 16px 0",
            width: "45%",
            header: {
              padding: "18px 13px 8px 19px",
              display: "flex",
              justifyContent: "space-between",
            },
            line: {
              display: "block",
              height: 1,
              width: "100%",
              borderBottom: "1px solid #D1D1D1",
              marginTop: 4,
              marginBottom: 4,
            },
            body: {
              margin: "6px 12px",
              display: "flex",
              justifyContent: "center",
              flexDirection: "column",
              itemContainer: {
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                marginBottom: 8,
              },
            },
          },
        },
        laborCodesInfo: {
          paddingLeft: 16,
          display: "flex",
          flexWrap: "wrap",
          flexDirection: "column",
          width: "100%",
          minWidth: "100%",
          header: {
            padding: "4px 8px",
            marginTop: 10,
            width: 150,
            fontFamily: "Roboto-Bold",
          },
          laborCodesContainer: {
            width: "100%",
            laborCodeItem: {},
          },
        },
      },
    },
  },
  floorPlanImageView: {
    padding: "31px 32px",
    backgroundColor: "#FFFFFF",
    borderRadius: 8,
    marginRight: 10,
    marginLeft: 10,
    marginTop: 24,
    header: {
      fontSize: 16,
      color: "#454545",
      letterSpacing: 0,
      marginTop: 6,
      marginBottom: 6,
      fontFamily: "Roboto-Bold",
    },
    image: {
      padding: 8,
      border: "1px solid #D1D1D1",
      borderRadius: 8,
      marginTop: 6,
    },
    infoContainer: {
      display: "flex",
      flexDirection: "column",
      fontSize: 12,
      color: "#454545",
      flexWrap: "wrap",
      width: "100%",
    },
  },
  body: {
    borderStyle: "none",
  },
  section: {
    top: 48,
  },
  line: {
    display: "block",
    height: 1,
    width: "100%",
    borderBottom: "1px solid #D1D1D1",
    marginTop: 18,
    marginBottom: 18,
  },
  colorPrimary: {
    color: "#0076C2",
  },
  mr6px: {
    marginRight: 6,
  },
  w30: {
    width: "30%",
  },
  table: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    marginBottom: 6,
    header: {
      row: {
        display: "flex",
        flexDirection: "row",
        cell: {
          width: "30%",
          border: "1px solid #dee2e6",
          padding: 3,
          alignItems: "center",
          justifyContent: "start",
          color: "#ffffff",
          backgroundColor: "#005FAA",
        },
      },
    },
    row: {
      display: "flex",
      flexDirection: "row",
      cell: {
        width: "30%",
        border: "1px solid #dee2e6",
        padding: 3,
        alignItems: "center",
        justifyContent: "start",
        color: "#454545c2",
      },
    },
  },
  projectHeading: {
    color: "#454545c2",
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
  },
});

const PdfDocument = ({ siteData, floors = [], options, productsData }) => {
  const { showSiteInfo, showProductView, showRoomView, showFloorPlanPictures, showCutSheetImages } = options;
  return (
    <Document style={styles.noBorder}>
      <Page style={styles.body} wrap size={"A4"}>
        <View style={styles.header} fixed>
          <View style={styles.header.container}>
            <Image style={styles.header.image} src={() => pdfLogo} />
          </View>
        </View>
        <View style={styles.section}>
          {showSiteInfo ? (
            <View style={styles.siteDetails}>
              <Text style={styles.siteDetails.header}>Site Information</Text>
              <View style={styles.line} />
              <View style={styles.siteDetails.siteInfoContainer}>
                <View style={styles.siteDetails.siteInfoContainer.infoItem}>
                  <Text style={styles.siteDetails.siteInfoContainer.label}>Site Name</Text>
                  <Text style={styles.siteDetails.siteInfoContainer.value}>{siteData.siteName}</Text>
                </View>
                <View style={styles.siteDetails.siteInfoContainer.infoItem}>
                  <Text style={styles.siteDetails.siteInfoContainer.label}>Site Address</Text>
                  <Text style={[styles.siteDetails.siteInfoContainer.value, { color: "#0076C2" }]}>
                    {siteData.siteAddress}
                  </Text>
                </View>
                <View style={styles.siteDetails.siteInfoContainer.infoItem}>
                  <Text style={styles.siteDetails.siteInfoContainer.label}>Account Number</Text>
                  <Text style={styles.siteDetails.siteInfoContainer.value}>{siteData.accountNumber}</Text>
                </View>
                <View style={styles.siteDetails.siteInfoContainer.infoItem}>
                  <Text style={styles.siteDetails.siteInfoContainer.label}>Account Name</Text>
                  <Text style={styles.siteDetails.siteInfoContainer.value}>{siteData.accountName}</Text>
                </View>
                <View style={styles.siteDetails.siteInfoContainer.infoItem}>
                  <Text style={styles.siteDetails.siteInfoContainer.label}>Store Number</Text>
                  <Text style={styles.siteDetails.siteInfoContainer.value}>{siteData.storeNumber}</Text>
                </View>
                <View style={styles.siteDetails.siteInfoContainer.infoItem}>
                  <Text style={styles.siteDetails.siteInfoContainer.label}>Store Name</Text>
                  <Text style={styles.siteDetails.siteInfoContainer.value}>{siteData.storeName}</Text>
                </View>
              </View>
            </View>
          ) : (
            <Text></Text>
          )}

          {showSiteInfo && <View break />}
          {showRoomView ? (
            <View style={styles.roomView} wrap>
              <Text style={styles.roomView.header}>Room View</Text>
              <View style={styles.line} />
              <View style={styles.roomView.roomInfoContainer}>
                {floors.map((project) => {
                  return project.layerInfoList?.map((layer) => {
                    return (
                      <>
                        {layer.rooms?.length === 0 ? (
                          <View wrap={false} style={{ width: "100%" }}>
                            <View style={styles.productView.productNameContainer}>
                              <Text style={styles.productView.productNameContainer.value}>Room: NA</Text>
                              <View style={styles.projectHeading}>
                                <Text>{`${project.name}-${layer.name}`}</Text>
                              </View>
                            </View>
                            <View style={styles.roomView.roomInfoContainer.cardContainer}>
                              <View style={styles.roomView.roomInfoContainer.cardContainer.roomInfoCard}>
                                <Text>No Rooms Available</Text>
                              </View>
                            </View>
                          </View>
                        ) : (
                          <Text></Text>
                        )}
                        {layer.rooms?.map((room) => {
                          return (
                            <View wrap={false} style={{ width: "100%" }} key={generateUUID()}>
                              <View style={styles.productView.productNameContainer}>
                                <Text style={styles.productView.productNameContainer.value}>Room: {room.name}</Text>
                                <View style={styles.projectHeading}>
                                  <Text>{`${project.name}-${layer.name}`}</Text>
                                </View>
                              </View>
                              <View style={styles.roomView.roomInfoContainer.cardContainer}>
                                <View style={styles.roomView.roomInfoContainer.cardContainer.roomInfoCard}>
                                  <View style={styles.w30}>
                                    <Text>Net Area (Sq Ft) {room.area}</Text>
                                  </View>
                                  <View style={styles.w30}>
                                    <Text>Room Perimeter {room.perimeter}</Text>
                                  </View>
                                  <View>
                                    <Text>Products {room.products?.length}</Text>
                                  </View>
                                </View>
                                <View style={styles.roomView.roomInfoContainer.cardContainer.productInfo}>
                                  <Text style={styles.productView.productInfoContainer.cardContainer.roomInfo.header}>
                                    Products
                                  </Text>
                                  <View style={styles.table}>
                                    {room.products?.length ? (
                                      <>
                                        <View style={styles.table.header.row}>
                                          <View style={styles.table.header.row.cell}>
                                            <Text>Product Name</Text>
                                          </View>
                                          <View style={styles.table.header.row.cell}>
                                            <Text>Type</Text>
                                          </View>
                                          <View style={styles.table.header.row.cell}>
                                            <Text>Amount</Text>
                                          </View>
                                        </View>
                                        {room.products?.map((product) => {
                                          return (
                                            <View style={styles.table.row} key={generateUUID()}>
                                              <View style={styles.table.row.cell}>
                                                <Text>{product.id}</Text>
                                              </View>
                                              <View style={styles.table.row.cell}>
                                                <Text>{product.type ? product.type : "NA"}</Text>
                                              </View>
                                              <View style={styles.table.row.cell}>
                                                <Text>{product.quantity ? product.quantity : "NA"}</Text>
                                              </View>
                                            </View>
                                          );
                                        })}
                                      </>
                                    ) : (
                                      <View style={styles.table.header.row}>
                                        <View style={styles.table.header.row.cell}>
                                          <Text>No Products Available</Text>
                                        </View>
                                      </View>
                                    )}
                                  </View>
                                </View>
                              </View>
                              <br />
                              <br />
                              <br />
                            </View>
                          );
                        })}
                      </>
                    );
                  });
                })}
              </View>
            </View>
          ) : (
            <Text></Text>
          )}

          {showRoomView && <View break />}
          {showProductView ? (
            <View style={styles.productView} wrap>
              <Text style={styles.roomView.header}>Product View</Text>
              <View style={styles.line} />
              <View style={styles.productView.productInfoContainer}>
                {productsData &&
                  Object.keys(productsData).map((projectKey) => {
                    return Object.keys(productsData[projectKey]).map((productKey) => {
                      if (productKey !== "cutSheetData") {
                        return (
                          <View wrap={false} style={{ width: "100%" }} key={generateUUID()}>
                            <View style={styles.productView.productNameContainer}>
                              <Text style={styles.productView.productNameContainer.value}>Product: {productKey}</Text>
                              <View style={styles.projectHeading}>
                                <Text>{`${productsData[projectKey][productKey].projectName}-${productsData[projectKey][productKey].floorName}`}</Text>
                              </View>
                            </View>
                            <View style={styles.productView.productInfoContainer.cardContainer} wrap>
                              <View style={styles.productView.productInfoContainer.cardContainer.productInfoCard} wrap>
                                <View
                                  style={
                                    styles.productView.productInfoContainer.cardContainer.productInfoCard.itemContainer
                                  }
                                >
                                  <Text
                                    style={
                                      styles.productView.productInfoContainer.cardContainer.productInfoCard
                                        .itemContainer.label
                                    }
                                  >
                                    Sales No.
                                  </Text>
                                  <Text
                                    style={
                                      styles.productView.productInfoContainer.cardContainer.productInfoCard
                                        .itemContainer.value
                                    }
                                  >
                                    {productsData[projectKey][productKey].salesNumber
                                      ? productsData[projectKey][productKey].salesNumber
                                      : "NA"}
                                  </Text>
                                </View>
                                <View
                                  style={
                                    styles.productView.productInfoContainer.cardContainer.productInfoCard.itemContainer
                                  }
                                >
                                  <Text
                                    style={
                                      styles.productView.productInfoContainer.cardContainer.productInfoCard
                                        .itemContainer.label
                                    }
                                  >
                                    Category
                                  </Text>
                                  <Text
                                    style={
                                      styles.productView.productInfoContainer.cardContainer.productInfoCard
                                        .itemContainer.value
                                    }
                                  >
                                    {productsData[projectKey][productKey].type
                                      ? productsData[projectKey][productKey].type
                                      : "NA"}
                                  </Text>
                                </View>
                                <View
                                  style={
                                    styles.productView.productInfoContainer.cardContainer.productInfoCard.itemContainer
                                  }
                                >
                                  <Text
                                    style={
                                      styles.productView.productInfoContainer.cardContainer.productInfoCard
                                        .itemContainer.label
                                    }
                                  >
                                    Actual Usage{" "}
                                    {productsData[projectKey][productKey].unit
                                      ? `(${productsData[projectKey][productKey].unit})`
                                      : ""}
                                  </Text>
                                  <Text
                                    style={
                                      styles.productView.productInfoContainer.cardContainer.productInfoCard
                                        .itemContainer.value
                                    }
                                  >
                                    {productsData[projectKey][productKey].actualUsage
                                      ? productsData[projectKey][productKey].actualUsage?.toFixed(2)
                                      : "NA"}
                                  </Text>
                                </View>
                                <View
                                  style={
                                    styles.productView.productInfoContainer.cardContainer.productInfoCard.itemContainer
                                  }
                                >
                                  <Text
                                    style={
                                      styles.productView.productInfoContainer.cardContainer.productInfoCard
                                        .itemContainer.label
                                    }
                                  >
                                    Linear Length
                                  </Text>
                                  <Text
                                    style={
                                      styles.productView.productInfoContainer.cardContainer.productInfoCard
                                        .itemContainer.value
                                    }
                                  >
                                    {productsData[projectKey][productKey].linearLength
                                      ? productsData[projectKey][productKey].linearLength
                                      : "NA"}
                                  </Text>
                                </View>
                                <View
                                  style={
                                    styles.productView.productInfoContainer.cardContainer.productInfoCard.itemContainer
                                  }
                                >
                                  <Text
                                    style={
                                      styles.productView.productInfoContainer.cardContainer.productInfoCard
                                        .itemContainer.label
                                    }
                                  >
                                    Net Area
                                  </Text>
                                  <Text
                                    style={
                                      styles.productView.productInfoContainer.cardContainer.productInfoCard
                                        .itemContainer.value
                                    }
                                  >
                                    {productsData[projectKey][productKey].netAreaSum
                                      ? productsData[projectKey][productKey].netAreaSum?.toFixed(2)
                                      : "NA"}
                                  </Text>
                                </View>
                                <View
                                  style={
                                    styles.productView.productInfoContainer.cardContainer.productInfoCard.itemContainer
                                  }
                                >
                                  <Text
                                    style={
                                      styles.productView.productInfoContainer.cardContainer.productInfoCard
                                        .itemContainer.label
                                    }
                                  >
                                    Room Perimeter
                                  </Text>
                                  <Text
                                    style={
                                      styles.productView.productInfoContainer.cardContainer.productInfoCard
                                        .itemContainer.value
                                    }
                                  >
                                    {productsData[projectKey][productKey].basePerimeterSum
                                      ? productsData[projectKey][productKey].basePerimeterSum
                                      : "NA"}
                                  </Text>
                                </View>
                                <View
                                  style={
                                    styles.productView.productInfoContainer.cardContainer.productInfoCard.itemContainer
                                  }
                                >
                                  <Text
                                    style={
                                      styles.productView.productInfoContainer.cardContainer.productInfoCard
                                        .itemContainer.label
                                    }
                                  >
                                    Waste(%)
                                  </Text>
                                  <Text
                                    style={
                                      styles.productView.productInfoContainer.cardContainer.productInfoCard
                                        .itemContainer.value
                                    }
                                  >
                                    {productsData[projectKey][productKey].modActualUsage
                                      ? productsData[projectKey][productKey].modActualUsage?.toFixed(2)
                                      : productsData[projectKey][productKey].actualUsage
                                        ? productsData[projectKey][productKey].actualUsage.toFixed(2)
                                        : "NA"}
                                  </Text>
                                </View>
                              </View>
                              <View style={styles.productView.productInfoContainer.cardContainer.roomInfo} wrap={false}>
                                <Text style={styles.productView.productInfoContainer.cardContainer.roomInfo.header}>
                                  Rooms
                                </Text>
                                <View style={styles.table}>
                                  {productsData[projectKey][productKey].rooms?.length ? (
                                    <>
                                      <View style={styles.table.header.row}>
                                        <View style={styles.table.header.row.cell}>
                                          <Text>Room Name</Text>
                                        </View>
                                        <View style={styles.table.header.row.cell}>
                                          <Text>Area</Text>
                                        </View>
                                        <View style={styles.table.header.row.cell}>
                                          <Text>Perimeter</Text>
                                        </View>
                                      </View>
                                      {productsData[projectKey][productKey].rooms?.map((room) => {
                                        return (
                                          <View style={styles.table.row} key={generateUUID()}>
                                            <View style={styles.table.row.cell}>
                                              <Text>{room.name}</Text>
                                            </View>
                                            <View style={styles.table.row.cell}>
                                              <Text>{room.area ? room.area : "NA"}</Text>
                                            </View>
                                            <View style={styles.table.row.cell}>
                                              <Text>{room.perimeter ? room.perimeter : "NA"}</Text>
                                            </View>
                                          </View>
                                        );
                                      })}
                                    </>
                                  ) : (
                                    <View style={styles.table.header.row}>
                                      <View style={styles.table.header.row.cell}>
                                        <Text>No Rooms Available</Text>
                                      </View>
                                    </View>
                                  )}
                                </View>
                              </View>
                              <View
                                style={styles.productView.productInfoContainer.cardContainer.laborCodesInfo}
                                wrap={false}
                              >
                                <Text
                                  style={styles.productView.productInfoContainer.cardContainer.laborCodesInfo.header}
                                >
                                  Labor Codes
                                </Text>
                                <View
                                  style={
                                    styles.productView.productInfoContainer.cardContainer.laborCodesInfo
                                      .laborCodesContainer
                                  }
                                  wrap
                                >
                                  <View style={styles.table}>
                                    {productsData[projectKey][productKey].siteLaborCodesData?.length ? (
                                      <>
                                        <View style={styles.table.header.row}>
                                          <View style={styles.table.header.row.cell}>
                                            <Text>Labor Code</Text>
                                          </View>
                                          <View style={styles.table.header.row.cell}>
                                            <Text>Description</Text>
                                          </View>
                                          <View style={styles.table.header.row.cell}>
                                            <Text>Quantity</Text>
                                          </View>
                                        </View>
                                        {productsData[projectKey][productKey].siteLaborCodesData?.map((laborCode) => {
                                          return (
                                            <View style={styles.table.row} key={generateUUID()}>
                                              <View style={styles.table.row.cell}>
                                                <Text>{laborCode.laborCode}</Text>
                                              </View>
                                              <View style={styles.table.row.cell}>
                                                <Text>{laborCode.laborCodeDesc?.toLowerCase()}</Text>
                                              </View>
                                              <View style={styles.table.row.cell}>
                                                <Text>{laborCode.quantity}</Text>
                                              </View>
                                            </View>
                                          );
                                        })}
                                      </>
                                    ) : (
                                      <View style={styles.table.header.row}>
                                        <View style={styles.table.header.row.cell}>
                                          <Text>No Labor Codes</Text>
                                        </View>
                                      </View>
                                    )}
                                  </View>
                                </View>
                              </View>
                            </View>
                          </View>
                        );
                      }
                    });
                  })}
              </View>
            </View>
          ) : (
            <Text></Text>
          )}

          {showProductView && <View break />}
          {showFloorPlanPictures ? (
            <View style={styles.floorPlanImageView}>
              <Text style={styles.floorPlanImageView.header}>Floor Plan Pictures</Text>
              <View style={styles.line} />
              <View style={styles.floorPlanImageView.infoContainer}>
                {floors.map((projectItem) => {
                  return projectItem?.layerInfoList?.map((layerItem) => {
                    if (layerItem.pictureData) {
                      return (
                        <View key={generateUUID()} wrap={false}>
                          <View style={styles.productView.productNameContainer}>
                            <View style={styles.projectHeading}>
                              <Text>{`${projectItem.name}-${layerItem.name}`}</Text>
                            </View>
                          </View>
                          <Image
                            src={() => `data:image/png;base64,${layerItem.pictureData?.split(",")[1]}`}
                            style={styles.floorPlanImageView.image}
                          />
                        </View>
                      );
                    }
                  });
                })}
              </View>
            </View>
          ) : (
            <Text></Text>
          )}

          {isShowFloorPlanPictures && <View break />}
          {showCutSheetImages ? (
            <View style={styles.floorPlanImageView}>
              <Text style={styles.floorPlanImageView.header}>Cut Sheet Pictures</Text>
              <View style={styles.line} />
              {productsData &&
                Object.keys(productsData).map((projectKey) => {
                  return productsData[projectKey]["cutSheetData"]?.map((cutSheetItem) => {
                    if (cutSheetItem.cutSheetImage) {
                      return (
                        <View key={generateUUID()} wrap={false}>
                          <View style={styles.productView.productNameContainer}>
                            <Text
                              style={styles.productView.productNameContainer.value}
                            >{`Product: ${cutSheetItem.productName}`}</Text>
                            <View style={styles.projectHeading}>
                              <Text>{`${cutSheetItem.projectName}-${cutSheetItem.layerName}`}</Text>
                            </View>
                          </View>
                          <Image
                            src={() => `data:image/png;base64,${cutSheetItem.cutSheetImage}`}
                            key={generateUUID()}
                            style={styles.floorPlanImageView.image}
                          />
                        </View>
                      );
                    }
                  });
                })}
            </View>
          ) : (
            <Text></Text>
          )}
        </View>
      </Page>
    </Document>
  );
};

export default PdfDocument;
